if (!customElements.get("show-more-content")) {
  customElements.define(
    "show-more-content",
    class extends HTMLElement {
      constructor() {
        super();
        this.onConnected = this.onConnected.bind(this);
        this.maxHeight = 65;
      }

      connectedCallback() {
        setTimeout(this.onConnected, 0);
      }

      onConnected() {
        const content = this.querySelector(".expandable-content");
        const button = this.querySelector("button");

        if (content.scrollHeight > this.maxHeight) {
          button.addEventListener("click", () =>
            this.toggleContent(content, button),
          );
          button.classList.remove("hidden");
        } else {
          button.classList.add("hidden");
        }
      }

      toggleContent(content, button) {
        if (content.classList.contains("expanded")) {
          content.classList.remove("expanded");
          content.style.maxHeight = `${this.maxHeight}px`;
          button.innerText = "Read More";
          content.style.overflow = "hidden";
        } else {
          content.classList.add("expanded");
          content.style.maxHeight = `${content.scrollHeight}px`;
          button.innerText = "Read Less";
          content.style.overflow = "visible";
        }
      }
    },
  );
}
